import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext();


const getLocalRefreshToken = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user?.refreshToken;
}

const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user?.accessToken;
}

const updateLocalAccessToken = (token) => {
  let user = JSON.parse(localStorage.getItem("user"));
  user.accessToken = token;
  localStorage.setItem("user", JSON.stringify(user));
}

const getLocalSystemToken = () => {
  const system = JSON.parse(localStorage.getItem("system"));
  return system?.systemToken;
}

const getSystemID = () => {
  const system = getLocalSystemToken();

  const data = system.split('.')[1];

  var donneesUTF8 = new TextDecoder('utf-8').decode(Uint8Array.from(atob(data), c => c.charCodeAt(0)));
  console.log(donneesUTF8);
  return JSON.parse(donneesUTF8).systemID;
}

const updateLocalSystemToken = (token) => {
  let system = JSON.parse(localStorage.getItem("system"));
  system.systemToken = token;
  localStorage.setItem("system", JSON.stringify(system));
}

const removeSystem = () => {
  localStorage.removeItem("system");
}

const getUser = () => {
  return JSON.parse(localStorage.getItem("user"));
}

const removeUser = () => {
  localStorage.removeItem("user");
}

const AuthProvider = ({ children }) => {
  // State to hold the authentication token
  const [user, setUser_] = useState(JSON.parse(localStorage.getItem("user")));
  const [system, setSystem_] = useState(JSON.parse(localStorage.getItem("system")));



  // Function to set the authentication token
  const setUser = (newToken) => {
    if (!newToken) {
      localStorage.removeItem("user");
    }
    setUser_(newToken);
  };

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  }, [user]);

  const setSystem = (newToken) => {
    if (!newToken) {
      localStorage.removeItem("system");
    }
    setSystem_(newToken);
  };

  useEffect(() => {
    if (system) {
      localStorage.setItem("system", JSON.stringify(system));
    } else {
      localStorage.removeItem("system");
    }

    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  }, [system, user]);

  // Memoized value of the authentication context
  const contextValue = useMemo(
    () => ({
      user,
      setUser,
      system,
      setSystem
    }),
    [user, system]
  );

  // Provide the authentication context to the children components
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;

export {getLocalRefreshToken, getLocalAccessToken, updateLocalAccessToken, getUser, removeUser, getLocalSystemToken, removeSystem, updateLocalSystemToken, getSystemID}
